module.exports = __webpack_public_path__ + "static/img/44301e55.svg";